import { parseZonedDateTime } from '@rematter/common/dateTime';

import { CustomAttributeRecord } from '~/shared/components/custom-attributes/types';
import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const customAttributesQueryAtom = createQueryAtomFactory(
  'settings.customAttributes',
  () => ({
    customAttributeDefinitions: {
      __args: {
        filter: {
          entityTypes: undefined,
        },
      },
      id: true,
      name: true,
      dataType: true,
      isDisabled: true,
      order: true,
      entityType: true,
      constraints: {
        maxLength: true,
        minLength: true,
        minValue: true,
        maxValue: true,
        multipleValues: true,
        required: true,
        unique: true,
        validationExpr: true,
        selectOptions: true,
        objectType: true,
      },
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
  {
    select: (data) =>
      data?.customAttributeDefinitions?.map(
        (att): CustomAttributeRecord => ({
          id: att.id,
          name: att.name,
          dataType: att.dataType,
          isDisabled: att.isDisabled,
          order: att.order,
          entityType: att.entityType,
          constraints: att.constraints,
          createdAt: parseZonedDateTime(att.timestamps.createdAt),
          updatedAt: parseZonedDateTime(att.timestamps.updatedAt),
        }),
      ),
  },
);
